import { NgModule, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
	MerchantSearch,
	IMerchantListPaging
} from '../models/EvoSalesPortalModel';
import { CacheService } from './cache.service';
import { EricCacheService } from './ericCache.service';
@NgModule({})
@Injectable()
export class MerchantService {
	private apiCache: Array<any> = [];
	private deferreds: Array<any> = [];
	constructor(private http: HttpClient, private cacheService: EricCacheService) {}

	public getAllMerchants() {
		return this.http.get('api/merchant/listall');
	}

	public getMerchantAddresses(id: number) {
		const url = 'api/merchant/Addresses/' + id.toString();
		return this.cacheService.get(url, this.http.get(url));
	}
	public getMerchantPhoneNumbers(id: number) {
		const url = 'api/merchant/PhoneNumbers/' + id.toString();
		return this.cacheService.get(url, this.http.get(url));
	}
	public getMerchantProfiles(id: string) {
		const url = 'api/merchant/Profiles/' + id.toString();
		return this.cacheService.get(url, this.http.get(url));
	}
	public getMerchantSalesHierarchy(mid: string) {
		const url = 'api/merchant/SalesHirerachy/' + mid.toString();
		return this.cacheService.get(url, this.http.get(url));
	}
	public getMerchantOwners(id: number) {
		const url = 'api/merchant/Owners/' + id.toString();
		return this.cacheService.get(url, this.http.get(url));
	}
	public getMerchantComp(id: number) {
		const url = 'api/merchant/Comp/' + id.toString();
		return this.cacheService.get(url, this.http.get(url));
	}
	public getMerchantNote(id: number) {
		const url = 'api/merchant/GetMerchantNote/' + id.toString();
		return this.cacheService.get(url, this.http.get(url));
	}
	public getMerchantContacts(id: number){
		const url = 'api/merchant/Contacts/' + id.toString();
		return this.cacheService.get(url, this.http.get(url));
	}

	public getMerchantNotesList(mid: number, startPage: number, maxRows: number = 25) {
		const url = 'api/merchant/GetMerchantNotesList?mid=' + mid.toString() + '&startPage=' + startPage.toString() +
			'&maxRows=' + maxRows.toString();
		return this.cacheService.get(url, this.http.get(url));
	}

	public getReportUrls(id: number) {
		const url = 'api/merchant/GetMerchantReportUrls/' + id.toString();
		const parms = new HttpParams().set('merchantID', id.toString());
		return this.cacheService.get(
			url + parms,
			this.http.get(url, { params: parms })
		);
	}

	public getMerchantEquipmentList(id: number) {
		const url = 'api/merchant/Equipments/' + id.toString();
		return this.cacheService.get(url, this.http.get(url));
	}

	// for use with typeAhead serching
	// public searchNames(term: string): Observable<Array<string>> {
	// 	return new Observable(obs => {
	// 		const search = new MerchantSearch();
	// 		search.Search = term;
	// 		this.search(search).subscribe((resp: Array<IMerchantRecord>) => {
	// 			obs.next(
	// 				resp.map((v: IMerchantRecord, i: number) => {
	// 					if (i < 10) {
	// 						const s = v.MerchantDescription;
	// 						const si = s.indexOf(' (');
	// 						const max_si = si < 0 ? 10 : si;
	// 						const desc = s.substring(0, max_si);
	// 						return desc;
	// 					}
	// 				})
	// 			);
	// 		});
	// 	});
	// }

	public search(search: MerchantSearch): Observable<any> {
		/* const body = this.cacheService.stringify(search);
		const cacheId = 'api/merchant/search/' + body;

		return this.cacheService.get(
			cacheId,
			this.http.post<IMerchantListPaging>(
				'api/merchant/search/',
				search,
				{
					headers: new HttpHeaders().set(
						'Content-Type',
						'application/json'
					)
				}
			)
		); */

		return this.http.post<IMerchantListPaging>(
			'api/merchant/search/',
			search,
			{
				headers: new HttpHeaders().set(
					'Content-Type',
					'application/json'
				)
			}
		);
	}
}
